//COPIED FROM CONFLUENCE
import placeHolderTemplate from '../resources/templates/placeholder';
import { getRte } from '../../facades/editor';
import window from 'window-or-global';
// eslint-disable-next-line no-restricted-imports
import $ from 'jquery';

export default function placeholder() {
	const placeHolderTypes = [];
	const placeHolderTypeMap = {};

	let EMPTY_CARET;
	let EMPTY_CARET_LI;

	if (window.tinymce.Env.ie) {
		EMPTY_CARET = '\uFEFF{$caret}';
		EMPTY_CARET_LI = '<p>{$caret}</p>';
	} else if (window.tinymce.Env.webKit) {
		EMPTY_CARET = '\uFEFF{$caret}<br>';
		EMPTY_CARET_LI = EMPTY_CARET;
	} else {
		EMPTY_CARET = '\uFEFF{$caret}';
		EMPTY_CARET_LI = EMPTY_CARET;
	}

	const Placeholder = {
		/**
		 * Inserts the placeholder into the current cursor position in the editor.
		 *
		 * Examples:
		 *   Placeholder.insertPlaceHolder('<p>Display text</p>', '<p>Activation text. Typing goes in here: "<span class="caret"></span>".</p>')
		 *   Placeholder.insertPlaceHolder('<p>Enter new tasks here:</p><ul class="inline-task-list"><li data-inline-task-id>First task</li></ul>', '<ul class="inline-task-list"><li data-inline-task-id><span class="caret"></span><br/></li></ul>')
		 *
		 * @param displayContent the content to display for the placeholder
		 */
		insertTextPlaceHolder(displayContent) {
			const template = placeHolderTemplate(EMPTY_CARET);
			const ph = $('<div></div>').append(template);
			displayContent && ph.find('.text-placeholder').html(displayContent);
			window.tinymce.activeEditor.execCommand('mceInsertContent', false, ph.html());
		},

		/**
		 * Removes the specified placeholder from the editor and places the cursor in its place
		 * @param ph DOM Element placeholder
		 */
		removePlaceholder(ph) {
			const ed = window.tinymce.activeEditor;
			const body = $(ed.getBody());
			let content = EMPTY_CARET;
			const parent = ph.parentElement;

			// Selecting of placeholder will not work (as the selection can get changed by handlePlaceholderNodeChange), so replace it with something selectable
			if (parent.nodeName === 'LI') {
				content = EMPTY_CARET_LI;
			}

			const nuElement = ed.dom.create('span', { id: 'placeholder-cursor' }, '&nbsp;');

			parent.replaceChild(nuElement, ph);

			const phCursor = body.find('#placeholder-cursor')[0];
			ed.selection.select(phCursor.firstChild);
			ed.dom.remove(phCursor, false);
			ed.execCommand('mceInsertContent', false, content);
		},

		/**
		 * @param typeSpec of the form: { type: "example", label: "Example", tooltip: "The does example", activation: { click: true, keypress: false } }
		 */
		addPlaceholderType(typeSpec) {
			if (!typeSpec || !typeSpec.type) {
				if (process.env.NODE_ENV !== 'production') {
					console.log('PlaceHolderRegister : unable to register new place holder type !');
				}
				return;
			}
			placeHolderTypes.push(typeSpec);
			placeHolderTypeMap[typeSpec.type] = typeSpec;
		},

		getPlaceholderTypes() {
			return [].concat(placeHolderTypes);
		},

		getPlaceholderType(type) {
			return placeHolderTypeMap[type];
		},
	};

	//TODO: remove export to global once we make sure none of other modules are accessing global obj
	getRte().Placeholder = Placeholder;

	return Placeholder;
}
